import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import HomeComponent from '../components/home/HomeComponent';
import { getCompanies, selectCompany, removeCurrentCompany } from '../store/actions/companies';

const mapStateToProps = ({ companies: { items, isLoading }, session: { user } }, { history }) => ({
    companies: items,
    companyIds: user.companies ? Object.keys(user.companies) : {},
    isLoading,
    history,
});

const mapDispatchToProps = {
    getCompanies,
    selectCompany,
    removeCurrentCompany,
};

const mergeProps = (
    { history, companyIds, companies, ...stateProps },
    { getCompanies, removeCurrentCompany, selectCompany }
) => ({
    ...stateProps,
    companies,
    getCompanies: () => {
        removeCurrentCompany();
        getCompanies(companyIds);
    },
    onCompanySelect: selectCompany,
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps, mergeProps)(HomeComponent));



// WEBPACK FOOTER //
// ./src/containers/HomeContainer.js